export default "__VITE_ASSET__B8t3ekgd__"